// TODO: refactor. This is already not a const, since the values are requested from api.
export const claimIds = [
    // TODO: check! This role didn't exist before. Just appears occasionally.
    'Admin',
    'Manager',
    'Settings',
    'Warehouse', // TODO: to delete after this claim is deleted on backend
    'PointOfIssuing',
    'CustomerManager',
    'CustomerHeadManager',
    'SupplierManager',
    'SupplierHeadManager',
];
